import styles from './styles.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useMemo } from 'react';
import { handleResetAll } from '@/lib/store/casino/actions';
import OrderByProvidersRenderer from '../OrderByProvidersRenderer';
import { Navigate, NavigationBreadcrumbs } from '@starsoft/common/components';
import { GameTagFilter } from '@/models/games/game-tag-filter.enum';
import { useRouter } from 'next/router';
import { RootState } from '@/lib/store';

export default function GametagHeaderInfo() {
  const { query } = useRouter();
  const tag: GameTagFilter | undefined = query.tag as GameTagFilter;

  const gameTags = useSelector((state: RootState) => state.gameTags.gameTags);

  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const page = useMemo(
    () => gameTags.find(gameTag => gameTag?.slug == tag),
    [tag, gameTags],
  );

  function resetCasino() {
    return () => {
      dispatch(handleResetAll());
    };
  }

  useEffect(resetCasino, [tag, dispatch]);

  if (!page) {
    return <Navigate replace to="/casino" />;
  }

  return (
    <div className={styles.container}>
      <NavigationBreadcrumbs
        to="/casino"
        lastPageLabel={t('tab_casino')}
        currentPageLabel={
          page?.id > 81
            ? page?.name
            : t(t(`game-tag:${page?.id}.name`) ?? 'tab_all', {
                app_provider: process.env.NEXT_PUBLIC_BET_NAME,
              })
        }
      />

      <OrderByProvidersRenderer />
    </div>
  );
}
